/* eslint-disable no-use-before-define */
import React from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import useAuth from '../../../hooks/useAuth';
import CssBaseline from '@material-ui/core/CssBaseline';
import clsx from 'clsx';
import {
  Box,
  Divider,
  Drawer,
  AppBar,
  Toolbar,
  IconButton,
  List,
  ListSubheader,
  Typography,
  makeStyles,
  withStyles,
} from '@material-ui/core';
import Account from './Account';
import NavItem from './NavItem';
import Notifications from './Notifications';
import Help from './Help';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import MenuIcon from '@material-ui/icons/Menu';
import './styles.css';
import Rules from 'src/Rules.json'
import {
  useDashboardContext
} from 'src/contexts/DashboardContext';
import Year from './Year';
import Stream from './Stream';

const ColorAppBar = withStyles({
  root: {
    backgroundColor: '#002F6D'
  }
})(AppBar);


function renderNavItems({ items, pathname, depth = 0 }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, pathname, depth }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, pathname, item, depth }) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        key={key}
        title={item.title}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    backgroundColor:'#ffffff'
  },
  root1: {
    display: 'flex',
    paddingLeft: 130,
    transitionDuration: 500,
    backgroundColor:'#ffffff'

  },

  desktopDrawer: {
    width: 130,
    height: '100%',
    backgroundColor:Rules.nav_top_bar.navbar_background_color,
  },

  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },

  menuButton: {
    // marginRight: theme.spacing(1)
  },
  hide: {
    display: 'none'
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },

  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  },
  action: {
    marginBottom: theme.spacing(1)
  }
}));



function renderRightNavItems({ items, pathname, depth = 0 }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceRightChildRoutes({ acc, item, pathname, depth }),
        []
      )}
    </List>
  );
}

function reduceRightChildRoutes({ acc, pathname, item, depth }) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
        status={item.status}
      >
        {renderRightNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        key={key}
        status={item.status}
        title={item.title}
      />
    );
  }

  return acc;
}



var Owner = {
  // subheader: 'FeePay Management Panel',
  items: [
    {
      title: 'Dashboard',
      href: '/app/home',
      icon: 'material-symbols-light:dashboard-outline',
    },
    {
      title: 'Faculties',
      href: '/app/admin/faculties',
      icon: 'clarity:employee-group-line',
    },
    {
      title: 'Schedules',
      href: '/app/admin/valuation_schedules',
      icon: 'grommet-icons:schedule-new',
    },
    {
      title: 'Courses',
      href: '/app/admin/courses',
      icon: 'hugeicons:course',
    },
    {
      title: 'Faculty Courses',
      href: '/app/admin/faculty_courses',
      icon: 'carbon:course',
    },
    {
      title: 'Valuators',
      href: '/app/admin/valuators',
      icon: 'clarity:employee-line',
    },
    {
      title: 'Moderators',
      href: '/app/admin/moderators',
      icon: 'carbon:user-admin',
    },
    {
      title: 'Va-Mo Mapping',
      href: '/app/admin/va-mo',
      icon: 'icon-park-outline:mind-mapping',
    },
    {
      title: 'Packets',
      href: '/app/admin/packets',
      icon: 'mingcute:red-packet-line',
    },
    {
      title: 'Answer Booklets',
      href: '/app/admin/answer_sheets',
      icon: 'ri:booklet-line',
    },
    
  ]
}

var AdminOwner = {
  items : [
    {
      title: 'Dashboard',
      href: '/app/home',
      icon: 'material-symbols-light:dashboard-outline',
    },
    {
      title: 'Faculties',
      href: '/app/admin/faculties',
      icon: 'clarity:employee-group-line',
    },
    {
      title: 'Schedules',
      href: '/app/admin/valuation_schedules',
      icon: 'grommet-icons:schedule-new',
    },
    {
      title: 'Courses',
      href: '/app/admin/courses',
      icon: 'hugeicons:course',
    },
    {
      title: 'Faculty Courses',
      href: '/app/admin/faculty_courses',
      icon: 'carbon:course',
    },
    {
      title: 'Valuators',
      href: '/app/admin/valuators',
      icon: 'clarity:employee-line',
    },
    {
      title: 'Moderators',
      href: '/app/admin/moderators',
      icon: 'carbon:user-admin',
    },
    {
      title: 'Va-Mo Mapping',
      href: '/app/admin/va-mo',
      icon: 'icon-park-outline:mind-mapping',
    },
    {
      title: 'Packets',
      href: '/app/admin/packets',
      icon: 'mingcute:red-packet-line',
    },
    {
      title: 'Answer Booklets',
      href: '/app/admin/answer_sheets',
      icon: 'ri:booklet-line',
    },
    {
      title: 'Faculties Billing',
      href: '/app/admin/faculties_billing',
      icon: 'clarity:employee-group-line',
    },
    {
      title: 'Reports',
      href: '/app/admin/reports',
      icon:'tabler:report-analytics'
    },
  ]
}
var Admin = {
  // subheader: 'FeePay Management Panel',
  items: [
    {
      title: 'Dashboard',
      href: '/app/valuator/home',
      icon: 'material-symbols-light:dashboard-outline',
    },
    {
      title: 'Valuation',
      href: '/app/valuators/packets',
      icon: 'carbon:exam-mode',
    },
    {
      title: 'Moderation',
      href: '/app/moderators/packets',
      icon: 'material-symbols-light:add-moderator-outline-rounded',
    },
    {
      title: 'Third Valuation',
      href: '/app/third_valuation/packets',
      icon: 'fluent-mdl2:column-right-two-thirds-edit',
    },
    {
      title: 'Revaluation',
      href: '/app/reval_valuation/packets',
      icon: 'icon-park-outline:data-arrival',
    },
    {
      title: 'Cross Valuation',
      href: '/app/cross_valuation/packets',
      icon: 'mdi:cross-celtic',
    }
  ]
}

const TopBar = ({ className,  onMobileNavOpen, ...rest }) => {
  const location = useLocation();
  const { user } = useAuth();
  const classes = useStyles();

  const { open, setOpen } = useDashboardContext();
  const handleDrawer = () => {
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };









 



  window.dispatchEvent(new Event('storage'));

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{ suppressScrollX: true }}>
      <Box pt={2.5} pb={1.4} px={1.5}>
          <Box mt={-1} ml={1.2} display="flex" justifyContent='center'>
            {open === true && (
             <>
              <IconButton
                color="inherit"
                size="small"
                aria-label="open drawer"
                onClick={handleDrawer}
                edge="start"
                className={clsx(classes.menuButton, open)}
              >
                <MenuIcon fontSize="large" style={{color:'#ffffff'}} />
              </IconButton>
               {/* <Box mr={2} /> */}
               {/* {open && <Box mt={1}>
                  <Typography
                    variant="h5"
                    style={{ color: '#ffffff', fontSize: '20px' }}
                  >
                    DVS
                  </Typography>
                </Box>

                } */}
                
</>
            )}
            {open === false && (
              <>
              <Box mr={1}/>
              <IconButton
                color="inherit"
                size="small"
                aria-label="open drawer"
                onClick={handleDrawer}
                edge="start"
                className={clsx(classes.menuButton1, open)}
              >
                <MenuOpenIcon fontSize="large" style={{color:'black'}}/>
              </IconButton></>
            )}
           
          </Box>
        </Box>{' '}
        <Box px={2} pt={0.5} pb={0}>
          {(user.user_group === 'coordinator') && (
            <List
              key={Owner.subheader}
              subheader={
                <ListSubheader disableGutters disableSticky>
                  {Owner.subheader}
                </ListSubheader>
              }
            >
              {renderNavItems({
                items: Owner.items,
                pathname: location.pathname
              })}
            </List>
          )}

{(user.user_group === 'owner' || user.user_group === 'admin' ) && (
            <List
              key={AdminOwner.subheader}
              subheader={
                <ListSubheader disableGutters disableSticky>
                  {AdminOwner.subheader}
                </ListSubheader>
              }
            >
              {renderNavItems({
                items: AdminOwner.items,
                pathname: location.pathname
              })}
            </List>
          )}

      {(user.user_group === 'valuator') && (
            <List
              key={Admin.subheader}
              subheader={
                <ListSubheader disableGutters disableSticky>
                  {Admin.subheader}
                </ListSubheader>
              }
            >
              {renderNavItems({
                items: Admin.items,
                pathname: location.pathname
              })}
            </List>
          )}
       
                 
           
          <Box mt={-1} />
        </Box>
      </PerfectScrollbar>

      <Box flexGrow={1} />
      <Box pt={2} />
      <Divider />
     
      <Divider />
    </Box>
  );





  return (
    <div className={classes.root}>
      <CssBaseline />
      <ColorAppBar className={open ? classes.root1 : classes.root} {...rest}>
        <Toolbar className={classes.toolbar}>
         
          {open === false && (
            <IconButton
            style={{color:'#000000'}}
            aria-label="open drawer"
              onClick={handleDrawer}
              edge="start"
              className={clsx(classes.menuButton, open)}
            >
              <MenuOpenRoundedIcon fontSize="large" />
            </IconButton>
          )}

          <Stream  />

          <Box ml={2} flexGrow={1} />
          {/* <Year /> */}
          <Notifications />
          <Help />
         
          <Box ml={2}>
            <Account />
          </Box>
        </Toolbar>
      </ColorAppBar>
    
      {
        <Drawer
          classes={{ paper: classes.desktopDrawer }}
          variant="persistent"
          anchor="left"
          open={open}
        >
          {content}
        </Drawer>
      }
     
    </div>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

TopBar.defaultProps = {
  onMobileNavOpen: () => {}
};

export default TopBar;
